export const accordion = () => {
  const accordions = document.querySelectorAll('.accordion');
  accordions.forEach(accordion => {
    const trigger = accordion.querySelector('.accordion-trigger');
    const content = accordion.querySelector('.accordion-content');
    if (!trigger || !content) return;
    const icon = trigger.querySelector('.accordion-icon');
    const contentInner = content.querySelector('.accordion-inner');
    if (!icon || !contentInner) return;
    
    let isAnimating = false;
    
    // 固定のアニメーション速度 (px/ms)
    const ANIMATION_SPEED = 600; // 800px per second
    const MIN_DURATION = 300; // 最小時間 (ms)
    const MAX_DURATION = 600; // 最大時間 (ms)
    
    const calculateDuration = (height) => {
      const duration = (height / ANIMATION_SPEED) * 1000;
      return Math.min(Math.max(duration, MIN_DURATION), MAX_DURATION);
    };
    
    const toggle = () => {
      if (isAnimating) return;
      
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        close();
      } else {
        open();
      }
    };
    
    const open = () => {
      isAnimating = true;
      trigger.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
      accordion.classList.add('is-open');
      const height = contentInner.offsetHeight;
      const duration = calculateDuration(height);
      
      content.style.transition = `height ${duration}ms ease-in-out`;
      content.style.height = `${height}px`;
      icon.style.transition = `transform ${duration}ms ease-in-out`;
      icon.style.transform = `rotate(90deg)`;
      
      const handleTransitionEnd = (e) => {
        if (e.propertyName !== 'height') return;
        content.style.height = 'auto';
        isAnimating = false;
        content.removeEventListener('transitionend', handleTransitionEnd);
      };
      
      content.addEventListener('transitionend', handleTransitionEnd);
    };
    
    const close = () => {
      isAnimating = true;
      const height = content.offsetHeight;
      const duration = calculateDuration(height);
      
      content.style.height = `${height}px`;
      icon.style.transform = `rotate(0deg)`;
      
      requestAnimationFrame(() => {
        content.style.transition = `height ${duration}ms ease-out`;
        content.style.height = '0';
        trigger.setAttribute('aria-expanded', 'false');
        content.setAttribute('aria-hidden', 'true');
        accordion.classList.remove('is-open');
      });
      
      const handleTransitionEnd = (e) => {
        if (e.propertyName !== 'height') return;
        isAnimating = false;
        content.removeEventListener('transitionend', handleTransitionEnd);
      };
      
      content.addEventListener('transitionend', handleTransitionEnd);
    };
    
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      toggle();
    });
    
    content.style.height = '0';
    content.style.overflow = 'hidden';
  });
};